import { esperienza, en } from "@/content";
import { useLang } from "@/lang";
import MacWindow from "@/components/MacWindow";
import Reveal, { MaskedLine } from "@/components/Reveal";

export default function Esperienza() {
    const { lang } = useLang();
    const ex = lang === "en" ? en.esperienza : esperienza;
    return (
        <MacWindow id="esperienza" testId="esperienza-section" title={ex.windowTitle} icon="doc">
            <div>
                <Reveal>
                    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-ink/60">
                        {ex.overline}
                    </p>
                </Reveal>
                <h2 className="mt-5 font-display text-4xl leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
                    <MaskedLine key={lang}>{ex.heading}</MaskedLine>
                </h2>
            </div>

            <div className="mt-14 md:mt-20">
                {ex.timeline.map((t, i) => (
                    <Reveal key={t.years} delay={0.08 * i}>
                        <article
                            data-testid={`timeline-item-${i}`}
                            className="hover-dither grid gap-3 border-t-2 border-ink py-8 transition-colors duration-150 last:border-b-2 md:grid-cols-12 md:gap-8 md:py-12"
                        >
                            <span className="font-accent-serif text-2xl text-ink/70 md:col-span-3 md:text-3xl">
                                {t.years}
                            </span>
                            <div className="md:col-span-8 md:col-start-5">
                                <h3 className="font-display text-2xl tracking-tight md:text-3xl">
                                    {t.role}
                                </h3>
                                <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-ink/60">
                                    {t.org}
                                </p>
                                <p className="mt-3 max-w-2xl text-base leading-relaxed text-ink/80">
                                    {t.description}
                                </p>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>

            <div className="mt-14 grid gap-12 md:mt-20 md:grid-cols-12">
                <Reveal className="md:col-span-5">
                    <h3 className="font-display text-2xl tracking-tight md:text-3xl">
                        {ex.skillsTitle}
                    </h3>
                    <ul className="mt-6">
                        {ex.skills.map((s, i) => (
                            <li
                                key={i}
                                data-testid={`skill-${i}`}
                                className="hover-dither border-t-2 border-ink py-4 text-base leading-relaxed text-ink/80 transition-colors duration-150 last:border-b-2"
                            >
                                {s}
                            </li>
                        ))}
                    </ul>
                    <div className="mt-8 border-2 border-ink bg-paper p-6 shadow-[5px_5px_0_#000]">
                        <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-ink/60">
                            {ex.specialtiesTitle}
                        </p>
                        <ul className="mt-4 space-y-3">
                            {ex.specialties.map((s, i) => (
                                <li
                                    key={i}
                                    data-testid={`specialty-${i}`}
                                    className="text-base leading-relaxed text-ink/80"
                                >
                                    {s}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Reveal>
                <Reveal delay={0.1} className="md:col-span-6 md:col-start-7">
                    <h3 className="font-display text-2xl tracking-tight md:text-3xl">
                        {ex.ambitiTitle}
                    </h3>
                    <div className="mt-6 space-y-7">
                        {ex.ambiti.map((a) => (
                            <div key={a.title} className="border-l-4 border-ink pl-6">
                                <p className="font-display text-lg tracking-tight md:text-xl">
                                    {a.title}
                                </p>
                                <p className="mt-2 text-base leading-relaxed text-ink/80">
                                    {a.text}
                                </p>
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </MacWindow>
    );
}
